import { render, staticRenderFns } from "./edit-club.vue?vue&type=template&id=7858c554"
import script from "./edit-club.vue?vue&type=script&lang=js"
export * from "./edit-club.vue?vue&type=script&lang=js"
import style0 from "./edit-club.vue?vue&type=style&index=0&id=7858c554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports